import { render } from "./index.vue?vue&type=template&id=735bb3cb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=735bb3cb&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735bb3cb"],['__file',"src/views/settings/printer/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "735bb3cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('735bb3cb', __exports__)) {
    console.log('reload')
    api.reload('735bb3cb', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=735bb3cb&scoped=true", () => {
    console.log('re-render')
    api.rerender('735bb3cb', render)
  })

}


export default __exports__